import { useEffect, useState } from 'react';
import axios from '../../axios';
import Breadcrumb from '../Breadcrumb/Breadcrumb';
import usePermisos from '../../hooks/usePermisos';
import NoPermissions from '../NoPermissions/NoPermissions';
import { Table, TableAvatar, TableBadge, useTableSort, useTablePagination } from '../UI';

// Lista de permisos requeridos para este componente
const PERMISOS_REQUERIDOS = [
    'users_read',
    'users_create',
    'users_update',
    'users_delete'
];

const Usuarios = () => {
    const ruteImgs = axios.defaults.baseURL;
    
    // Hook personalizado para permisos
    const { permisos, loading: loadingPermisos, tienePermiso } = usePermisos(PERMISOS_REQUERIDOS);
    
    const [usuarios, setUsuarios] = useState([]);
    const [loader, setLoader] = useState(true);
    
    // Hook de sorting - ordena los datos originales
    const { sortedData, sortConfig, handleSort } = useTableSort(usuarios);
    
    // Hook de paginación - pagina los datos ordenados
    const { 
        paginatedData, 
        page, 
        setPage, 
        itemsPerPage, 
        setItemsPerPage, 
        totalItems 
    } = useTablePagination(sortedData, { page: 1, itemsPerPage: 10 });

    useEffect(() => {
        axios.get('api/users')
            .then(res => {
                console.log("res", res.data);
                setUsuarios(res.data);
                setLoader(false);
            })
            .catch(e => {
                console.log(e, 'Error todos los usuarios');
                setLoader(false);
            });
    }, []);

    const _delete = (usuario) => {
        if (window.confirm("Realmente deseas borrar a este administrador, si lo borras no se podra recuperar despues")) {
            axios.delete(`api/users/${usuario.id}`)
                .then(res => {
                    // TODO: Reemplazar con notificación de Tailwind
                    alert(res.data.message);
                    setUsuarios(usuarios.filter(u => u.id !== res.data.user.id));
                })
                .catch(e => console.log("error", e));
        }
    };

    // Configuración de columnas
    const columns = [
        {
            key: 'avatar',
            label: '',
            width: '60px',
            render: (_, usuario) => (
                <TableAvatar 
                    src={usuario.image ? ruteImgs + usuario.image : null}
                    name={usuario.name}
                    size="md"
                />
            )
        },
        {
            key: 'id',
            label: 'ID',
            sortable: true,
        },
        {
            key: 'name',
            label: 'Nombre',
            sortable: true,
        },
        {
            key: 'email',
            label: 'Correo',
            sortable: true,
        },
         {
            key: 'phone',
            label: 'Teléfono'
        },
        {
            key: 'rol',
            label: 'Rol',
            render: (_, usuario) => usuario.roles?.[0]?.name || '-'
        },
        {
            key: 'sucursales',
            label: 'Sucursal',
            render: (_, usuario) => (
                <div className="space-y-0.5">
                    {usuario.sucursals?.map((sucursal, i) => (
                        <div key={i} className="text-sm">{sucursal.nombre_sucursal}</div>
                    )) || '-'}
                </div>
            )
        },
        {
            key: 'created_at',
            label: 'Creado el',
            sortable: true,
            render: (value) => new Date(value).toLocaleDateString()
        },
        {
            key: 'updated_at',
            label: 'Modificado el',
            sortable: true,
            render: (value) => new Date(value).toLocaleDateString()
        },
        {
            key: 'activo',
            label: 'Status',
            align: 'center',
            sortable: true,
            render: (value) => <TableBadge status={Number(value)} />
        },
    ];

    // Configuración de acciones
    const actions = [
        {
            type: 'edit',
            to: (row) => `${row.id}`,
            tooltip: 'Editar',
            permission: 'users_update',
        },
        {
            type: 'view',
            to: (row) => `detail/${row.id}`,
            tooltip: 'Ver Detalle',
            permission: 'users_read',
        },
        {
            type: 'delete',
            onClick: _delete,
            tooltip: 'Eliminar',
            permission: 'users_delete',
        },
    ];

    // Si aún está cargando permisos
    if (loadingPermisos) {
        return (
            <div>
                <div className='container-admin-menu'>
                    <Breadcrumb hasButton={false} hasFilters={false} />
                </div>
                <div className='container-admin-container'>
                    <div className='container-admin z-depth-1 p-4'>
                        <div className="flex justify-center py-10">
                            <span className="text-gray-500">Cargando...</span>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    // Si no tiene permiso de lectura
    if (!tienePermiso('users_read')) {
        return (
            <div>
                <div className='container-admin-menu'>
                    <Breadcrumb hasButton={tienePermiso('users_create')} hasFilters={false} />
                </div>
                <div className='container-admin-container'>
                    <div className='container-admin z-depth-1'>
                        <NoPermissions />
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div>
            <div className='container-admin-menu'>
                <Breadcrumb hasButton={tienePermiso('users_create')} hasFilters={false} />
            </div>
            <div className='container-admin-container'>
                <div className='container-admin z-depth-1 p-4'>
                    <Table
                        columns={columns}
                        data={paginatedData}
                        actions={actions}
                        permissions={permisos}
                        loading={loader}
                        striped={true}
                        hoverable={true}
                        emptyMessage="No hay usuarios registrados"
                        sorting={{
                            field: sortConfig.field,
                            direction: sortConfig.direction,
                            onSort: handleSort
                        }}
                        pagination={{
                            page,
                            itemsPerPage,
                            totalItems,
                            onPageChange: setPage,
                            onItemsPerPageChange: setItemsPerPage
                        }}
                    />
                </div>
            </div>
        </div>
    );
};

export default Usuarios;